import React from 'react';
import LinkifyText from './LinkifyText';

const LIGHT = {
  textPrimary: '#3d2510',
  textSecondary: '#5e3a1a',
  textMuted: '#8B6F47',
  detailCardBg: 'rgba(255,255,255,.95)',
  detailTextBg: 'rgba(94,58,26,.04)',
  cardBorder: 'rgba(94,58,26,.1)',
  linkColor: '#2563eb',
};

/** 對齊 WeeklyActivityFront 月曆展開／詳情彈窗（不含櫃台欄位） */
export default function WeeklyActivityPreviewPublic({ activity, theme = 'light' }) {
  const a = activity || {};
  const T = LIGHT;
  const venueColor = a.venue_color || '#4ade80';
  const start = String(a.activity_time || '').trim();
  const end = String(a.end_time || '').trim();
  const timeText = start && end ? `${start} ~ ${end}` : (start || end);

  return (
    <div style={{
      background: T.detailCardBg,
      borderRadius: 10,
      padding: '12px 14px',
      borderLeft: `4px solid ${venueColor}`,
      border: `1px solid ${T.cardBorder}`,
      borderLeftWidth: 4,
      borderLeftColor: venueColor,
    }}
    >
      <div style={{ fontSize: 18, fontWeight: 700, color: T.textPrimary, marginBottom: 4 }}>
        {a.name || '（活動名稱）'}
      </div>
      {a.images && a.images.length > 0 && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 6, marginBottom: 8 }}>
          {a.images.map((url, idx) => (
            <img
              key={idx}
              src={url}
              alt=""
              style={{
                width: 140, height: 140, objectFit: 'cover', borderRadius: 8,
                border: `1px solid ${T.cardBorder}`,
              }}
            />
          ))}
        </div>
      )}
      <div style={{ fontSize: 14, color: T.textSecondary, marginBottom: 4 }}>
        {a.activity_date ? `${a.activity_date} · ` : ''}
        {timeText}
        {a.venue ? ` · 場地：${a.venue}` : ''}
      </div>
      {a.organizer && (
        <div style={{ fontSize: 13, color: T.textMuted, marginBottom: 4 }}>主辦：{a.organizer}</div>
      )}
      {a.consumption_type && (
        <div style={{ fontSize: 13, color: T.textMuted, marginBottom: 4 }}>消費方式：{a.consumption_type}</div>
      )}
      {a.detail && (
        <div style={{ marginTop: 8 }}>
          <div style={{ fontSize: 13, fontWeight: 700, letterSpacing: 1, color: T.textPrimary, marginBottom: 6 }}>活動介紹</div>
          <div style={{
            fontSize: 13, color: T.textSecondary, whiteSpace: 'pre-wrap', lineHeight: 1.6,
            padding: '8px 10px', background: T.detailTextBg, borderRadius: 8,
          }}
          >
            <LinkifyText text={a.detail} linkColor={T.linkColor} />
          </div>
        </div>
      )}
      {a.activity_flow && (
        <div style={{ marginTop: 10 }}>
          <div style={{ fontSize: 13, fontWeight: 700, letterSpacing: 1, color: T.textPrimary, marginBottom: 6 }}>活動流程</div>
          <div style={{
            fontSize: 13, color: T.textSecondary, whiteSpace: 'pre-wrap', lineHeight: 1.6,
            padding: '8px 10px', background: T.detailTextBg, borderRadius: 8,
          }}
          >
            <LinkifyText text={a.activity_flow} linkColor={T.linkColor} />
          </div>
        </div>
      )}
      {a.registration_link && (
        <span style={{
          display: 'inline-block', marginTop: 10, marginRight: 8, padding: '8px 20px',
          background: '#1677ff', color: '#fff', borderRadius: 8, fontSize: 15, fontWeight: 600,
        }}
        >
          報名連結
        </span>
      )}
      {a.registrationSlug && (
        <span style={{
          display: 'inline-block', marginTop: 10, padding: '8px 20px',
          background: '#531dab', color: '#fff', borderRadius: 8, fontSize: 15, fontWeight: 600,
        }}
        >
          立即報名
        </span>
      )}
    </div>
  );
}
